import React, { Fragment } from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import TicketRuleAbnormal from '@features/TicketRuleAbnormal';
import { I_MiniRuleInfo } from '@Redux/confirmation/interfaces';

import Spinner from '@features/ui/Spinner';

interface I_TicketRuleProps {
    miniRule: {
        data?: I_MiniRuleInfo[];
        isLoading?: boolean;
    };
}

interface I_Detail {
    name: string | null,
    desc: string | string[] | null,

}

// MP / 長榮華航
const TicketRule = ({ miniRule }: I_TicketRuleProps) => {
    const moduleName = 'ticketRule';
    const miniRuleIsLoading = miniRule.isLoading;

    const miniData = miniRule.data && miniRule.data[0];
    const reissue = miniData?.PenaltyInfo?.ReissuePenaltyDetail; // 改票
    const refund = miniData?.PenaltyInfo?.RefundPenaltyDetail; // 退票


    const choicesSeat = miniData?.FareFamilyPenaltyDetail; // 選位
    const otherPenaltyDetail = miniData?.OtherPenaltyDetail; // 退/改票說明 注意事項
    
    if (miniRuleIsLoading) return <Spinner />;
    if (!miniData) return <TicketRuleAbnormal />;

    // 整理物件
    const orderOtherPenaltyDetail = () => {
        const curTicketRuleArr: any = []
        if (miniData?.StayDesc) {
            curTicketRuleArr.push(
                {
                    name: "機票效期",
                    desc: miniData?.StayDesc,
                },
            )
        }
        if (reissue) {
            curTicketRuleArr.push(
                {
                    name: reissue?.Title,
                    desc: reissue?.PenaltyFee.PenaltyDesc,
                },
            )
        }
        if (refund) {
            curTicketRuleArr.push(
                {
                    name: refund?.Title,
                    desc: refund?.PenaltyFee.PenaltyDesc,

                },
            )
        }
        // 取消預選座位欄位(待刪除)
        if (choicesSeat && choicesSeat[0]?.name) {
            curTicketRuleArr.push(
                {
                    name: choicesSeat[0]?.name,
                    desc: choicesSeat[0]?.TicketRuleDescs[0].Desc,
                },
            )
        }
        if (otherPenaltyDetail) {
            otherPenaltyDetail.forEach((detail) => {
                const otherRule = []
                otherRule.push(detail.TicketRuleDescs.map((info) => { return info.Desc }))
                curTicketRuleArr.push({
                    name: detail.name,
                    desc: otherRule,
                })
            })
        }
        return curTicketRuleArr
    }
    // 判斷優先顯示順序
    const sortedData = orderOtherPenaltyDetail()

    return (
        <div className={cN(moduleName, styles[`${moduleName}`])}>

            {sortedData?.map((detail: I_Detail, i: number) =>
            (
                <div className={styles.col} key={i}>
                    <div className={styles.title}>{detail.name}</div>
                    <div className={styles.content}>
                        {typeof (detail.desc) === "string" ?
                            detail.desc ?? '依航空公司規定'
                            : detail.desc?.map((info, DetailIndex) => {
                                return (
                                    <Fragment key={DetailIndex}>
                                        <pre
                                            dangerouslySetInnerHTML={{
                                                __html: info
                                                    ? info
                                                    : '依航空公司規定',
                                            }}
                                        />
                                        {detail.desc && detail.desc[DetailIndex + 1] && <br />}
                                    </Fragment>
                                )
                            })
                        }
                    </div>
                </div>
            )
            )}
        </div>
    );
};

export default TicketRule;
function typeOf(Desc: string | null) {
    throw new Error('Function not implemented.');
}

